import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Link from '@mui/material/Link';
import TableCell from 'components/TableCell';
import SortableEntityTableRow, {
  SortableEntityTableRowProps,
} from 'components/SortableEntityTableRow';

import { LabelListRow_label$key } from '__generated__/LabelListRow_label.graphql';

type Props = SortableEntityTableRowProps & {
  label: LabelListRow_label$key;
};

const types = {
  ADMIN: 'Administruojama',
  SYSTEM: 'Sisteminė',
};

const LabelListRow: FC<Props> = ({ label, ...props }) => {
  const labelData = useFragment(
    graphql`
      fragment LabelListRow_label on Label {
        id
        name
        type

        ...SortableEntityTableRow_entity
      }
    `,
    label
  );

  const { id, name, type } = labelData;

  return (
    <SortableEntityTableRow entity={labelData} {...props}>
      <TableCell>
        <Link href={id}>{name}</Link>
      </TableCell>

      <TableCell center>{types[type]}</TableCell>
    </SortableEntityTableRow>
  );
};

export default LabelListRow;
